module.exports = __webpack_public_path__ + "static/media/ex11.474bc9a9.jpg";